import axios from 'axios';
import authHeader from './auth-header';

const API_URL = 'https://cloud.gmi-aero.com:5000/';

class UserService {
  getPublicContent() {
    return axios.get(API_URL + 'all');
  }

  getUserBoard() {
    return axios.get(API_URL + 'user', { headers: authHeader() });
  }
  getUserData(id) {
    return axios.get(API_URL + 'appusers/'+id, { withCredentials: true });
  }
  getUserConsoles(id) {
     
    return axios.get(API_URL + 'console/wsp/'+id, { withCredentials: true });
  }
  getAllConsoles() {
    
    return axios.get(API_URL + 'console/', { withCredentials: true });
  }

  getModeratorBoard() {
    return axios.get(API_URL + 'mod', { headers: authHeader() });
  }

  getAdminBoard() {
    return axios.get(API_URL + 'admin', { headers: authHeader() });
  }
}

export default new UserService();